import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
export default [{
  path: '/lucky/home/:activityId',
  name: ROUTE_NAME.LUCKY_HOME,
  meta: {
    title: '抽奖',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "lucky" */
      '@/pages/lucky/index.vue')
    };
  }
}];